export enum ESpecialDailyOfferType {
	LONG_TERM = 'long-term',
	MID_TERM = 'mid-term',
	SHORT_TERM = 'short-term',
}
